/**
 * @ngdoc Filter
 * @name vrmFormattedAbsolute
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .filter('vrmFormattedAbsolute', vrmFormattedAbsolute);

    function vrmFormattedAbsolute() {
        return function(value){
            if (value.charAt(0) === '-') {
                return value.substring(1);
            } else {
                return value;
            }
        }
    }

})();
